import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';

const APP_TITLE = 'Skipify Merchant Portal';

type RouteHandle = {
  title?: string;
};

const useDocumentTitle = (): void => {
  const matches = useMatches();

  useEffect(() => {
    const title = matches
      .map((match) => (match.handle as RouteHandle | undefined)?.title)
      .filter((value): value is string => Boolean(value))
      .pop();

    document.title = title ? `${title} | ${APP_TITLE}` : APP_TITLE;
  }, [matches]);
};

export { useDocumentTitle };
